import React from "react";

const ICheckRounded = ({
  color = "#fff",
  width = "14",
  height = "14",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M11.8125 7C11.8125 4.34213 9.65787 2.1875 7 2.1875C4.34213 2.1875 2.1875 4.34213 2.1875 7C2.1875 9.65787 4.34213 11.8125 7 11.8125C9.65787 11.8125 11.8125 9.65787 11.8125 7ZM12.6875 7C12.6875 10.1411 10.1411 12.6875 7 12.6875C3.85888 12.6875 1.3125 10.1411 1.3125 7C1.3125 3.85888 3.85888 1.3125 7 1.3125C10.1411 1.3125 12.6875 3.85888 12.6875 7Z"
        fill={color}
      />
      <path
        d="M7 1.75C9.89949 1.75 12.25 4.10051 12.25 7C12.25 9.89949 9.89949 12.25 7 12.25C4.10051 12.25 1.75 9.89949 1.75 7C1.75 4.10051 4.10051 1.75 7 1.75ZM10.0374 5.01245C9.80964 4.78472 9.44036 4.78472 9.21256 5.01245L5.83333 8.39168L4.49577 7.05412C4.26798 6.82638 3.89869 6.82638 3.6709 7.05412C3.44311 7.28191 3.44315 7.65118 3.6709 7.87899L5.4209 9.62899C5.6487 9.85679 6.01796 9.85679 6.24577 9.62899L10.0374 5.83732C10.2652 5.60951 10.2652 5.24024 10.0374 5.01245Z"
        fill={color}
      />
    </svg>
  );
};

export default ICheckRounded;
